module.exports = __webpack_public_path__ + "images/category_lp/bike/store_images/1_9f98de4f40a9e03f60aaf37166db8905.png";